import _ from 'lodash';

import {
  Firebase,
  getCurrentTimestamp,
  accountId,
  isProduction,
  omitDeleted,
  addKeysAsIds,
  unwrapDoc,
  unwrapDocs,
  logAndDispatchErrorForAction,
  callIfFunction,
} from './../util';

import {
  getCoreProfileIdForTalentProfile
} from './../util/data';

import {
  AppConfigRef,
  OrgConfigRef,
  AssessmentVersionsRef,
  AssessmentsRef,
  ScoredAssessmentsRef,
  OrganizationScoredAssessmentsRef,
  UsersRef,
} from './../util/refs';

import {
  //Assessments
  LOAD_ASSESSMENT,
  LOAD_ASSESSMENT_COMPLETE,

  FETCH_MY_ASSESSMENTS,
  FETCH_MY_ASSESSMENTS_SUCCESS,
  FETCH_MY_ASSESSMENTS_ERROR,

  UPDATE_ASSESSMENT,
  UPDATE_ASSESSMENT_SUCCESS,
  UPDATE_ASSESSMENT_ERROR,

  SCORE_ASSESSMENT,
  SCORE_ASSESSMENT_SUCCESS,
  SCORE_ASSESSMENT_ERROR

} from './types';

const scoredProfilesHaveCoreProfile = (scoredProfiles, coreProfileId) => {
  console.log('scoredProfilesHaveCoreProfile: ', scoredProfiles, coreProfileId);

  let hasCoreProfile = false;

  _.each(scoredProfiles, organizationCustomOrCoreProfile => {

    //get base profile if is custom profile, otherwise use id
    let coreProfileIdForOrganizationProfile = getCoreProfileIdForTalentProfile(organizationCustomOrCoreProfile);

    if(coreProfileIdForOrganizationProfile === coreProfileId){
      hasCoreProfile = true;
    }
  });

  return hasCoreProfile;
}

const organizationConfigHasAnyOfCoreProfilesEnabled = (scoredProfiles, coreProfileIdsToCheck) => {
  console.log('organizationConfigHasAnyOfCoreProfilesEnabled', scoredProfiles, coreProfileIdsToCheck);

  let hasMatchingProfile = false;

  _.each(coreProfileIdsToCheck, coreProfileIdToCheck => {
    if(scoredProfilesHaveCoreProfile(scoredProfiles, coreProfileIdToCheck)){
      hasMatchingProfile = true;
    }
  });

  console.log('hasMatchingProfile: ', hasMatchingProfile);

  return hasMatchingProfile;
}

const mapVisibleAssessmentQuestionsForProfile = (assessmentData, assessmentConfig, talentProfileId) => {

  console.log('mapVisibleAssessmentQuestionsForProfile: ', assessmentData, assessmentConfig, talentProfileId);

  let questions = {};

  _.each(assessmentData.questions, question => {

    let questionShouldBeAsked = false;

    //if talent inventory => always ask
    if(question.questionFormat === 'likert'){
      if(question.inventoryType === 'talent'){
        questionShouldBeAsked = true;
      }
      //else if likert and predictive for ANY role live for company
      else if(question.inventoryType === 'skill'){
        //only show questions that are predictive for ANY core profile currently enabled for this organization
        console.log('checking skills question: ', question);
        questionShouldBeAsked = organizationConfigHasAnyOfCoreProfilesEnabled(assessmentConfig.scoredProfiles, Object.keys(question.predictiveIndexes));
      }
    }
    else if(question.questionFormat === 'choice'){
      if(question.inventoryType === 'sjt'){
        const coreProfileIdForCurrentTalentProfile = getCoreProfileIdForTalentProfile(talentProfileId);

        //is predictive for the "current" talent profile
        questionShouldBeAsked = Object.keys(question.predictiveIndexes).indexOf(coreProfileIdForCurrentTalentProfile) > -1;
      }
      else{
        //not implemented / nothing
      }
    }
    else{
      //not implemented / nothing
    }

    //disable non-active experiment questions
    if(question.experimental){
      //if experimental question and org not running experiemnts / this experiment
      if(!assessmentConfig.experiments || assessmentConfig.experiments.indexOf(question.experimentId) === -1){
        questionShouldBeAsked = false;
      }
    }

    //TODO disable non-localized questions if taking test in different locale?

    if(questionShouldBeAsked){
      questions[question.id] = {
        id: question.id,
        text: question.text,
        ...(question.choices && {choices: question.choices}),
        legacyId: question.legacyId || null,
        questionIndex: question.questionIndex,
        questionFormat: question.questionFormat,
        inventoryType: question.inventoryType,
      };
    }
  });

  // console.log('questions: ', questions);

  return questions;
}

export function initializeAssessment(assessmentConfig, callback){

  return dispatch => {
    const userId = accountId();

    const {
      assessmentName,
      playbookVersion,
      assessmentVersion,
      profile,
      profileName,
      organization,
      locale,
      batchLabel,
      grouping,
      scoredProfiles,
      withholdResults,
      scoringAlgoVersion,
    } = assessmentConfig;

    console.log('initializing with: ', assessmentConfig);

    AssessmentVersionsRef().doc(assessmentConfig.assessmentVersion).get().then(doc => {
      let assessmentVersionData = unwrapDoc(doc);

      OrgConfigRef().doc(organization).get().then(doc => {

        const organizationConfig = unwrapDoc(doc);

        const newAssessment = {
          assessmentConfig: {
            assessmentName,
            profileName,
            playbookVersion,
            assessmentVersion,
            profile,
            organization,
            locale,
            scoredProfiles,
            ...(withholdResults && {withholdResults}),
            ...(batchLabel && {batchLabel}),
            ...(grouping && {grouping}),
            ...(scoringAlgoVersion && {scoringAlgoVersion}),
          },
          questions: mapVisibleAssessmentQuestionsForProfile(assessmentVersionData, assessmentConfig, profile),
          userId,
          createdOn: getCurrentTimestamp(),
          lastModified: getCurrentTimestamp(),
          status: 'inprogress',
          responses: {}
        }

        AssessmentsRef().add(newAssessment).then(newAssessmentRef => {
          callIfFunction(callback, {
            _id: newAssessmentRef.id,
            ...newAssessment
          });
        });

        //if user in org, update pendingAssessment to inProgressAssessment to show that this assessment is in progress
        UsersRef().doc(userId).get().then(() => {
          //user is in organiaztion, update their pendingAssessments object status
          UsersRef().doc(userId).update({
            'pendingAssessment.status': 'inprogress'
          });
        }).catch(err => {
          //do nothing
        });

      });
    });
  }
}

export function fetchLatestScoredTalentAssessmentForUser(userId, callback){
  OrganizationScoredAssessmentsRef().where("userId", "==", userId).get().then(docs => {
    const scoredAssessmentsForUser = unwrapDocs(docs);

    console.log('scoredAssessmentsForUser: ', scoredAssessmentsForUser);

    const latestAssessmentsForUser = _.orderBy(scoredAssessmentsForUser, assessment => {
      return assessment.scoredOn.toDate();
    }, 'desc')[0];

    console.log('latestAssessmentsForUser: ', latestAssessmentsForUser);

    callback(latestAssessmentsForUser || null);

  }).catch(err => { console.error('ERROR: Fetch latest scored assessment for user: ', userId, err) });
}

export function fetchMyAssessments(callback){
  return dispatch => {

    dispatch({ type: FETCH_MY_ASSESSMENTS });

    console.log('fetching where account id == ', accountId());

    AssessmentsRef().where("userId", "==", accountId()).get().then(docs => {
      const myAssessments = unwrapDocs(docs);

      dispatch({
        type: FETCH_MY_ASSESSMENTS_SUCCESS,
        payload: myAssessments
      });

      callIfFunction(callback, myAssessments);

    }).catch(err => logAndDispatchErrorForAction('Fetch my assessments', err, dispatch, FETCH_MY_ASSESSMENTS_ERROR));
  }
}

export function updateAssessment(assessment, callback){
  return dispatch => {
    dispatch({ type: UPDATE_ASSESSMENT });

    const updatedAssessment = {
      ...assessment,
      lastModified: getCurrentTimestamp()
    }

    AssessmentsRef().doc(updatedAssessment._id).update(updatedAssessment).then(() => {

      dispatch({
        type: UPDATE_ASSESSMENT_SUCCESS,
        payload: updatedAssessment
      });

      callIfFunction(callback, updatedAssessment);

    }).catch(err => logAndDispatchErrorForAction('Update assessment', err, dispatch, UPDATE_ASSESSMENT_ERROR));
  }
}

export function updateAssessmentResponses(assessmentWithUpdatedResponses, callback){
  return dispatch => {
    dispatch({ type: UPDATE_ASSESSMENT });

    AssessmentsRef().doc(assessmentWithUpdatedResponses._id).update({
      responses: assessmentWithUpdatedResponses.responses,
      lastModified: getCurrentTimestamp()
    }).then(() => {

      dispatch({
        type: UPDATE_ASSESSMENT_SUCCESS,
        payload: assessmentWithUpdatedResponses
      });

      callIfFunction(callback, assessmentWithUpdatedResponses);

    }).catch(err => logAndDispatchErrorForAction('Update assessment responses', err, dispatch, UPDATE_ASSESSMENT_ERROR));
  }
}

export function submitAssessmentForScoring(assessmentId, callback){

  return dispatch => {
    dispatch({ type: SCORE_ASSESSMENT });

    const submitForScoring = Firebase.functions().httpsCallable('submitAssessmentForScoring');

    submitForScoring({
      id: assessmentId,
    }).then(result => {

      dispatch({
        type: SCORE_ASSESSMENT_SUCCESS,
        payload: result
      });

      callIfFunction(callback, result);

    }).catch(err => {
      logAndDispatchErrorForAction('Score assessment', err, dispatch, SCORE_ASSESSMENT_ERROR);
    });
  }
}

export function completeAssessment(assessment, callback){

  return dispatch => {
    dispatch({ type: UPDATE_ASSESSMENT });

    const updatedAssessment = {
      ...assessment,
      status: 'complete',
      completedOn: getCurrentTimestamp(),
      lastModified: getCurrentTimestamp()
    }

    AssessmentsRef().doc(updatedAssessment._id).update(updatedAssessment).then(() => {

      dispatch({
        type: UPDATE_ASSESSMENT_SUCCESS,
        payload: updatedAssessment
      });

      callIfFunction(callback, updatedAssessment);

    }).catch(err => logAndDispatchErrorForAction('Update assessments', err, dispatch, UPDATE_ASSESSMENT_ERROR));

  }
}



// WEBPACK FOOTER //
// ./src/actions/assessments.js